export const NEON_PALETTE = [
  '#00f5ff', '#bf00ff', '#00ff88', '#ff6b35',
  '#ff0080', '#ffcc00', '#00bfff', '#7fff00',
  '#ff4da6', '#a78bfa',
] as const;

export type CategoryKey = 'strategy' | 'idea' | 'execution';
export const CATEGORY_MAP: Record<CategoryKey, { label: string; color: string; icon: string }> = {
  strategy:  { label: 'Estratégia', color: '#00bfff', icon: 'my_location' },
  idea:      { label: 'Ideia',      color: '#bf00ff', icon: 'lightbulb' },
  execution: { label: 'Execução',   color: '#00ff88', icon: 'bolt' },
};

export type NodeKindKey = 'idea' | 'text' | 'image' | 'url' | 'universe' | 'doc';
export const NODE_DEFAULTS: Record<string, { defaultIcon: string; defaultSize: number; shape: 'circle' | 'rect'; defaultRectW?: number; defaultRectH?: number }> = {
  idea:     { defaultIcon: 'lightbulb', defaultSize: 22, shape: 'circle' },
  text:     { defaultIcon: 'edit_note', defaultSize: 50, shape: 'rect', defaultRectW: 100, defaultRectH: 60 },
  image:    { defaultIcon: 'image',     defaultSize: 22, shape: 'circle' },
  universe: { defaultIcon: 'public',    defaultSize: 36, shape: 'circle' },
  url:      { defaultIcon: 'language',  defaultSize: 22, shape: 'circle' },
  doc:      { defaultIcon: 'description', defaultSize: 22, shape: 'circle' },
};

export const UNIQUE_ICONS = [
  'lightbulb', 'bolt', 'target', 'psychology', 'neurology',
  'rocket_launch', 'visibility', 'public', 'favorite', 'star',
  'verified', 'schedule', 'flag', 'bug_report', 'api',
  'science', 'code', 'data_object', 'database', 'language',
  'architecture', 'engineering', 'design_services', 'palette', 'mic',
  'videocam', 'article', 'book', 'school', 'forest',
] as const;

export function uid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // UUID v4 fallback — crypto.randomUUID unavailable in HTTP (non-secure) contexts.
  // crypto.getRandomValues IS available even without HTTPS.
  const b = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(b);
  } else {
    for (let i = 0; i < 16; i++) b[i] = (Math.random() * 256) | 0;
  }
  b[6] = (b[6]! & 0x0f) | 0x40; // version 4
  b[8] = (b[8]! & 0x3f) | 0x80; // variant 10xx
  const h = (i: number) => b[i]!.toString(16).padStart(2, '0');
  return `${h(0)}${h(1)}${h(2)}${h(3)}-${h(4)}${h(5)}-${h(6)}${h(7)}-${h(8)}${h(9)}-${h(10)}${h(11)}${h(12)}${h(13)}${h(14)}${h(15)}`;
}

export function ha(hex: string, alpha: number): string {
  try {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r},${g},${b},${alpha})`;
  } catch {
    return `rgba(0,245,255,${alpha})`;
  }
}

export function rnd(n: number): number {
  return Math.random() * n * 2 - n;
}

export function escHtml(s: string): string {
  const div = document.createElement('div');
  div.textContent = s || '';
  return div.innerHTML;
}
